import { Button } from 'primereact/button'
import { MouseEventHandler, PropsWithChildren, ReactNode } from 'react'
import { LoadingIcon } from '../Icons'
import { classNames } from 'primereact/utils'

type IconButtonProps = {
  title?: string
  type?: 'button' | 'submit' | 'reset' | undefined
  severity?: 'secondary' | 'success' | 'info' | 'warning' | 'danger' | 'help' | undefined
  disabled?: boolean
  loading?: boolean
  clear?: boolean
  link?: boolean
  icon: ReactNode
  onClick?: MouseEventHandler<HTMLButtonElement>
  dataPrAt?: string
  additionalClassName?: string
  label?: string
}

const IconButton = ({ severity, type = "button", icon, title, disabled, clear, loading, link, onClick, dataPrAt, additionalClassName, label }: IconButtonProps & PropsWithChildren) => {
  return (
    <Button
      type={type}
      onClick={onClick}
      severity={severity}
      disabled={disabled}
      link={link}
      className={
        classNames(
          "icon-button cursor-pointer flex items-center justify-center gap-1 shrink-0", // Added flex and gap for equal spacing
          { '!bg-transparent': clear, '!cursor-not-allowed !opacity-50': disabled }
        ) + (additionalClassName || '')}
      tooltip={title}
      tooltipOptions={{ position: 'bottom', showDelay: 150 }}
      data-pr-at={dataPrAt || 'center bottom'}
    >
      {loading && <LoadingIcon className="w-4 h-4 fill-white animate-spin" />}
      {!loading && icon}
      {label && <span className="mt-1">{label}</span>}
    </Button>
  )
}

export default IconButton
